import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import {
  GridComponent,
  Inject,
  ColumnDirective,
  ColumnsDirective,
  CommandColumn,
  Page,
  Filter,
  Toolbar,
  ExcelExport,
  Sort,
  Resize,
  Group,
  Freeze,
} from "@syncfusion/ej2-react-grids";
import { useIrnStore } from "../../../store/useIrnstore";
import { message, Spin } from "antd";
import ImagePreviewModal from "./imageModal";
import generatePdfFromHTML from "./generatePdfFromHtml";

const ListRegisterGrid = ({}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const { irnList, downloadDoc, getPrintDetailByIrn } = useIrnStore();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const [fileName, setFileName] = useState("");
  const [fileType, setFileType] = useState("");
  const handlePrint = async (irn) => {
    try {
      setLoading(true);
      const response = await getPrintDetailByIrn(irn);
      await generatePdfFromHTML(response);
    } catch (error) {
      console.error("Error fetching print details:", error);
      message.error("Failed to fetch print details.");
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async (name) => {
    try {
      setLoading(true);
      const response = await downloadDoc(name);
      const extension = name.split(".").pop().toLowerCase();

      let type = "other";
      if (["jpg", "JPG", "jpeg", "png", "webp"].includes(extension)) {
        type = "image";
      } else if (extension === "pdf") {
        type = "pdf";
      }
      setImageUrl(response);
      setFileName(name);
      setFileType(type);
      setOpen(true);
    } catch (error) {
      console.error("Error downloading document:", error);
      message.error("Failed to download document.");
    } finally {
      setLoading(false);
    }
  };

  const actionTemplate = (row) => {
    return (
      <div style={{ display: "flex", gap: "6px", justifyContent: "center" }}>
        {/* Print Button */}
        <button
          className="e-control e-btn e-flat e-primary"
          title="Print"
          onClick={(e) => {
            e.stopPropagation();
            row?.IRNNo && handlePrint(row?.IRNNo);
          }}
          disabled={loading}
        >
          <span className="e-icons e-print"></span>
        </button>
        <button
          className="e-control e-btn e-flat e-info"
          title="Download POD "
          onClick={(e) => {
            e.stopPropagation();
            row?.PODDocument && handleDownload(row?.PODDocument);
          }}
          disabled={loading}
        >
          <span className="e-icons e-download"></span>
        </button>
        <button
          className="e-control e-btn e-flat e-success"
          title="Download Reciver PIC"
          onClick={(e) => {
            e.stopPropagation();
            row?.ReceiverPic && handleDownload(row?.ReceiverPic);
          }}
          disabled={loading}
        >
          <span className="e-icons e-download"></span>
        </button>
      </div>
    );
  };
  function parseDDMMYYYYWithTime(dateStr) {
    if (!dateStr) return null;

    // Example: "22/12/2025 11:57:10 AM"
    const [datePart, timePart, meridian] = dateStr.split(" ");

    const [day, month, year] = datePart.split("/").map(Number);
    let [hours, minutes, seconds] = timePart.split(":").map(Number);

    if (meridian === "PM" && hours < 12) hours += 12;
    if (meridian === "AM" && hours === 12) hours = 0;

    return new Date(year, month - 1, day, hours, minutes, seconds);
  }

  const formattedData = irnList.map((item) => ({
    ...item,
    PoExpiryDate: item.PoExpiryDate ? new Date(item.PoExpiryDate) : null,
    IRNDate: item.IRNDate ? parseDDMMYYYYWithTime(item.IRNDate) : null,
  }));
  let gridInstance;
  const toolbarClick = (args) => {
    if (gridInstance && args.item.id === "BrokerGrid_excelexport") {
      gridInstance.excelExport();
    }
  };

  return (
    <>
      {loading && (
        <div
          style={{
            textAlign: "center",
          }}
        >
          <Spin size="large" />
        </div>
      )}
      <div
        className={`grid_compact ${isMobile ? "e-bigger" : ""}`}
        style={{
          position: "relative",
          marginTop: "10px",
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          padding: "6px",
          marginBottom: "20px",
        }}
      >
        <Row>
          <Col>
            <GridComponent
              ref={(g) => (gridInstance = g)}
              id="BrokerGrid"
              dataSource={formattedData}
              allowPaging={true}
              allowSorting={true}
              allowFiltering={true}
              filterSettings={{ type: "Excel" }}
              toolbar={["ExcelExport", "Search"]}
              allowExcelExport={true}
              toolbarClick={toolbarClick}
              enableAdaptiveUI={isMobile}
              rowRenderingMode={isMobile ? "Vertical" : "Horizontal"}
              gridLines="Both"
              height={"300px"}
              pageSettings={{
                pageSizes: [10, 20, 30, 40, 50, "All"],
                pageCount: 10,
              }}
              rowHeight={isMobile ? "" : 32}
              allowResizing={true}
              dataBound={() => {
                if (!isMobile && gridInstance) {
                  gridInstance.autoFitColumns();
                }
              }}
              // rowDataBound={()}
              // commandClick={handleCommandClick}
            >
              <ColumnsDirective>
                <ColumnDirective
                  field="serialNo"
                  headerText="S No"
                  textAlign="Left"
                  width="70"
                  allowFiltering={false}
                />
                <ColumnDirective
                  field="IRNNo"
                  headerText="IRN No"
                  width="150"
                  textAlign="Center"
                  allowFiltering={false}
                />
                <ColumnDirective
                  field="StoreCode"
                  headerText="Store Code"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="StoreName"
                  headerText="Store Name"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="SupplierCode"
                  headerText="Supplier Code"
                  width="200"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="SupplierName"
                  headerText="Supplier Name"
                  width="250"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="PODate"
                  headerText="PO Date"
                  width="250"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="PONo"
                  headerText="PO No"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="PoQty"
                  headerText="Po Qty"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="POValue"
                  headerText="PO Value"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="IRNQty"
                  headerText="IRN Qty"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="IRNValue"
                  headerText="IRN Value"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="NoOfInvoice"
                  headerText="No Of Invoice"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="PoExpiryDate"
                  headerText="Po Expiry Date"
                  width="150"
                  textAlign="Left"
                  type="date"
                  format="dd/MM/yyyy"
                />
                <ColumnDirective
                  field="IRNBy"
                  headerText="IRN By"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="IRNDate"
                  headerText="IRN Date"
                  width="150"
                  textAlign="Left"
                  type="date"
                  format="dd/MM/yyyy"
                />

                <ColumnDirective
                  headerText="Actions"
                  // commands={userCommands}
                  width="120"
                  textAlign="Center"
                  freeze="Right"
                  template={actionTemplate}
                />
              </ColumnsDirective>

              <Inject
                services={[
                  CommandColumn,
                  Page,
                  Filter,
                  Toolbar,
                  ExcelExport,
                  Sort,
                  Group,
                  Resize,
                  Freeze,
                ]}
              />
            </GridComponent>
          </Col>
        </Row>
        {open && (
          <ImagePreviewModal
            open={open}
            onClose={() => {
              setOpen(false);
              setImageUrl(null);
              setFileName("");
              setFileType("");
            }}
            imageUrl={imageUrl}
            fileName={fileName}
            fileType={fileType}
          />
        )}
      </div>
    </>
  );
};

export default ListRegisterGrid;
